<template>
  <div class="order">
    <div class="filter-container">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="75px">
        <el-form-item label="适用车型">
          <el-input v-model="searchForm.carModel" placeholder="请输入适用车型"></el-input>
        </el-form-item>
        <el-form-item label="适用国家">
          <el-select filterable clearable v-model="searchForm.countryIds" placeholder="请选择国家">
            <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" plain @click="handleResetQuery">重置</el-button>
      </el-form>
    </div>
    <div class="table-container">
      <div class="table-btn">
        <el-button type="text" icon="el-icon-plus" @click="handleAddOrEdit('新增')">新增</el-button>
      </div>
      <el-table :data="tableData" highlight-current-row border stripe>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="carModel" label="适用车型" min-width="120" align="center"></el-table-column>
        <el-table-column prop="warrantyTime" label="质保时间(月)" min-width="120" align="center"></el-table-column>
        <el-table-column prop="mileage" label="里程(km)" min-width="120" align="center"></el-table-column>
        <el-table-column prop="countryNames" label="适用国家" min-width="200" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createStaffName" label="创建人" min-width="100" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleAddOrEdit('编辑', scope.row)">编辑</el-button>
            <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination :total="total" :page.sync="page" :limit.sync="pageSize" @pagination="handlePaginationChange" />
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="适用国家" prop="countryId">
          <el-select
            v-model="form.countryId"
            filterable
            clearable
            placeholder="请选择适用国家"
            style="width: 100%"
            @change="onCountryChange"
          >
            <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用车型" prop="carModel">
          <el-select
            v-model="form.carModel"
            filterable
            allow-create
            clearable
            placeholder="请选择或输入适用车型"
            style="width: 100%"
            :loading="modelLoading"
          >
            <el-option v-for="item in carModelOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="质保时间(月)" prop="warrantyTime">
          <el-input-number class="number-input" :controls="false" v-model="form.warrantyTime" placeholder="请输入质保时间(月)" style="width: 200px">
          </el-input-number>

        </el-form-item>
        <el-form-item label="里程(km)" prop="mileage">
          <el-input-number class="number-input" :controls="false" v-model="form.mileage" placeholder="请输入质保里程(km)" style="width: 200px">
          </el-input-number>

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="lang-but" type="primary" @click="handleSave">确定</el-button>
        <el-button  class="lang-but" type="primary" plain @click="dialogVisible = false">取消</el-button>

      </div>
    </el-dialog>

    <!-- 查看适用国家弹窗 -->
    <viewWarrantyCountryDialog ref="viewCountryDialog" />
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import viewWarrantyCountryDialog from "./viewWarrantyCountryDialog.vue";
import { getSession } from "@/util/localStor";
import { warrantyTimeList, warrantyTimeSave, warrantyTimeDelete, getModelsByCountry } from "@/api/seek";

export default {
  components: {
    pagination,
    viewWarrantyCountryDialog
  },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      searchForm: {},
      dialogVisible: false,
      dialogTitle: "",
      modelLoading: false,
      form: {
        warrantyTimeConfigId: "",
        countryId: "",
        countryIds: "",
        countryNames: "",
        carModel: "",
        warrantyTime: 24,
        mileage: 0
      },
      rules: {
        countryId: [{ required: true, message: "请选择适用国家", trigger: "change" }],
        carModel: [{ required: true, message: "请输入适用车型", trigger: "blur" }],
        warrantyTime: [{ required: true, message: "请输入质保时间", trigger: "blur" }]
      },
      nationList: [],
      carModelOptions: []
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
    this.getList();
  },
  methods: {
    async getList() {
      const res = await warrantyTimeList({
        data: this.searchForm,
        page: { pageNum: this.page, pageSize: this.pageSize }
      });
      if (res.status === "0") {
        this.tableData = res.data.records;
        this.total = res.data.count;
      }
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleResetQuery() {
      this.searchForm = {};
      this.page = 1;
      this.getList();
    },
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    async onCountryChange() {
      // 保存当前车型值（编辑回显时需要保留）
      const prevCarModel = this.form.carModel;
      this.carModelOptions = [];
      const countryId = this.form.countryId;
      if (!countryId) return;
      // 获取国家名称
      const country = this.nationList.find(n => String(n.id) === String(countryId));
      if (!country) return;
      this.form.countryNames = country.name;
      this.form.countryIds = String(countryId);
      // 调用接口查询车型
      this.modelLoading = true;
      try {
        const res = await getModelsByCountry({ data: country.name });
        if (res.status === 0 || res.status === "0") {
          this.carModelOptions = res.data || [];
          // 如果之前已有车型值（编辑场景），恢复它
          if (prevCarModel) {
            this.form.carModel = prevCarModel;
          }
        }
      } catch (e) {
        this.carModelOptions = [];
      }
      this.modelLoading = false;
    },
    handleAddOrEdit(type, row) {
      if (type === "新增") {
        this.dialogTitle = "新增质保时间设置";
        this.form = {
          warrantyTimeConfigId: "",
          countryId: "",
          countryIds: "",
          countryNames: "",
          carModel: "",
          warrantyTime: 24,
          mileage: 0
        };
        this.carModelOptions = [];
      } else {
        this.dialogTitle = "编辑质保时间设置";
        this.form = Object.assign({}, row);
        // 编辑时回显 countryId（单值）
        this.form.countryId = "";
        if (this.form.countryIds) {
          const ids = String(this.form.countryIds).split(",");
          if (ids.length > 0) this.form.countryId = ids[0];
        }
        // 编辑时根据国家加载车型
        this.$nextTick(() => {
          if (this.form.countryId) {
            this.onCountryChange();
          }
        });
      }
      this.dialogVisible = true;
    },
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        const params = Object.assign({}, this.form);
        // 单国家时 countryIds 取 countryId，countryNames 在 onCountryChange 中已设置
        params.countryIds = this.form.countryId ? String(this.form.countryId) : "";
        const res = await warrantyTimeSave(params);
        if (res.status === "0") {
          this.$DonMessage.success("保存成功");
          this.dialogVisible = false;
          this.getList();
        } else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除当前质保时间设置吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await warrantyTimeDelete({ data: { warrantyTimeConfigId: row.warrantyTimeConfigId } });
        if (res.status === "0") {
          this.$DonMessage.success("删除成功");
          this.getList();
        } else {
          this.$DonMessage.error(res.message);
        }
      });
    }
  }
};
</script>

<style src="@/assets/css/qualityStyle.css"></style>
